module.exports = __webpack_public_path__ + "images/decathlon_small6bcd6e64a6e3892737b7e505447c91b6.png";